import useGetRejectReasonInitialValues from './useGetRejectReasonInitialValues'

export default useGetRejectReasonInitialValues
